/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type PaymentApiResourceStatus = typeof PaymentApiResourceStatus[keyof typeof PaymentApiResourceStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentApiResourceStatus = {
  created: 'created',
  pending: 'pending',
  processing: 'processing',
  success: 'success',
  failed: 'failed',
} as const;
